import Vue from "vue";
import Router from "vue-router";
//import Expertise from "@/components/expertise/List";
import Experts from "@/components/expert/List";
import GroupOrgs from "@/components/group_orgs/List";
import MonitoringLizingOrgs from "@/components/monitoring_lizing_orgs/List";
import Projects from "@/components/project/List";
import ProjectEdit from "@/components/project/Edit";
import Questions from "@/components/expert/Questions.vue";
import ExpertMPT from "@/components/expertise/ExpertMPT";
import ProjectDocuments from "@/components/project/Documents";
import ExpertStatus from "@/components/project/ExpertStatus";
import ExpertStatusOld from "@/components/project/ExpertStatusOld";
import ProjectNotifications from "@/components/project/Notifications";
import ProjectInstitutes from "@/components/project/Institutes";
import ProjectMeeting from "@/components/project/Meeting";
import Auth from "@/components/Auth";
import Home from "@/components/Home";
import Support from "@/components/Support";
import Idea from "@/components/Idea";
import Methodics from "@/components/Methodics";
import ApiService from "@/common/api.service";
import AddInfo from "@/components/project/AddInfo";
import EAList from "@/components/expert/EAList";
import GOList from "@/components/group_orgs/GOList";
import AddDZ from "@/components/project/AddDZ";
import Indicators from "@/components/project/Indicators";
import Requests from "@/components/requests/List";
import RequestEdit from "@/components/requests/Edit";
import Administration from "@/components/administration/List";
import ExpertiseAll from "@/components/expertise/ExpertiseAll.vue";
import Conference from "@/components/expert/Conference/Conference.vue";
import ScenarioRequest from "@/components/project/ScenarioRequest.vue";
import Acceptance from "@/components/administration/points/Acceptance.vue";
import AdminStatuses from "@/components/administration/points/Statuses.vue";
import AdminStatusesColumn from "@/components/administration/points/AdminStatusesColumn.vue";
import InfoDocument from "@/components/administration/points/InfoDocument.vue";
import SubmittedProjects from "@/components/project/SubmittedProjects.vue";
import ExpertiseDetails from "@/components/project/ExpertiseDetails.vue";
import EDS from "@/components/administration/points/EDS.vue";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/DAIT",
      name: "Auth",
      component: Auth
    },
    {
      path: "/auth",
      name: "AuthRedirect",
      component: Auth
    },
    {
      path: "/expertise",
      name: "Expertise",
      //component: Expertise
      component: ExpertiseAll
    },
    {
      path: "/allexperties",
      name: "ExpertiseAll",
      component: ExpertiseAll
    },
    {
      path: "/experts",
      name: "Experts",
      component: Experts
    },
    {
      path: "/experts/:id",
      name: "EAList",
      component: EAList
    },
    {
      path: "/projects",
      name: "Projects",
      component: Projects
    },
    {
      path: "/submitted_projects",
      name: "SubmittedProjects",
      component: SubmittedProjects
    },
    {
      path: "/project/new/",
      name: "ProjectNew",
      component: ProjectEdit
    },
    {
      path: "/project/edit/:id/general",
      redirect: to => {
        return { name: "ScenarioRequest", params: { id: to.params.id } };
      }
    },
    {
      path: "/project/general/:id",
      name: "ScenarioRequest",
      component: ScenarioRequest
    },
    {
      path: "/project/edit/:id",
      name: "ProjectEdit",
      component: ProjectEdit
    },
    {
      path: "/experts/questions/:id/:projectId",
      name: "Questions",
      component: Questions
    },
    {
      path: "/project/edit/:id/:step",
      name: "ProjectEditStep",
      component: ProjectEdit
    },
    {
      path: "/project/expert-mpt/:id",
      name: "ExpertMPT",
      component: ExpertMPT
    },
    {
      path: "/project/documents/:id",
      name: "ProjectDocuments",
      component: ProjectDocuments
    },
    {
      path: "/project/documents/:id/:page",
      name: "ProjectDocumentsPlan",
      component: ProjectDocuments
    },
    {
      path: "/project/notifications/:id",
      name: "ProjectNotifications",
      component: ProjectNotifications
    },
    {
      path: "/project/institutes/:id",
      name: "ProjectInstitutes",
      component: ProjectInstitutes
    },
    {
      path: "/project/meeting/:id",
      name: "ProjectMeeting",
      component: ProjectMeeting
    },
    {
      path: "/project/add-info/:id",
      name: "AddInfo",
      component: AddInfo
    },
    {
      path: "/project/dz/:id",
      name: "AddDZ",
      component: AddDZ
    },

    {
      path: "/project/indicators/:id",
      name: "Indicators",
      component: Indicators
    },
    {
      path: "/project/expert-status-old/:id",
      name: "ExpertStatusOld",
      component: ExpertStatusOld
    },
    {
      path: "/project/expert-status/:id",
      name: "ExpertStatus",
      component: ExpertStatus
    },
    {
      path: "/project/expert-status/:id/expertise/:expertiseId",
      name: "ExpertiseDetails",
      component: ExpertiseDetails
    },
    {
      path: "/support",
      name: "Support",
      component: Support
    },
    {
      path: "/idea",
      name: "Idea",
      component: Idea
    },
    {
      path: "/methodics",
      name: "Methodics",
      component: Methodics
    },
    {
      path: "/group_orgs",
      name: "GroupOrgs",
      component: GroupOrgs
    },
    {
      path: "/conference",
      name: "Conference",
      component: Conference
    },
    {
      path: "/experts/conference/:id",
      name: "ExpertsQuestions",
      component: Conference
    },
    {
      path: "/monitoring_lizing_orgs",
      name: "MonitoringLizingOrgs",
      component: MonitoringLizingOrgs
    },
    {
      path: "/group_org_list",
      name: "GOList",
      component: GOList
    },
    {
      path: "/requests",
      name: "Requests",
      component: Requests
    },
    {
      path: "/requests/:id",
      name: "RequestEdit",
      component: RequestEdit
    },
    {
      path: "/administration",
      name: "Administration",
      component: Administration
    },
    {
      path: "/admin/acceptance_documents",
      name: "Acceptance",
      component: Acceptance
    },
    {
      path: "/admin/status_documents/:type?",
      name: "AdminStatuses",
      component: AdminStatuses
    },
    {
      path: "/admin/status_documents/:type/:id",
      name: "AdminStatusesColumn",
      component: AdminStatusesColumn
    },
    {
      path: "/admin/info_document/:id",
      name: "InfoDocument",
      component: InfoDocument
    },
    {
      path: "/admin/eds",
      name: "EDS",
      component: EDS
    }
  ],
  mode: "history"
});

router.afterEach(to => {
  ApiService.post("/services/addRecordLogUserURI/", {
    URI: to.path
  });
});

export default router;
